import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ArticleResponse } from './types';

type GetArticleProps = {
  artistId: string;
  articleId: string;
};

export async function getArticle({ artistId, articleId }: GetArticleProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const url = `/web/studio/artists/${artistId}/articles/${articleId}`;
  const response = await api.executeGetRequest<ObjectResponse<ArticleResponse>>(url);

  return response.data;
}
